const healthIndex = {
  namespaced: true,
  state: {
    data: null
  },
  getters: {
    getHealthIndex: state => {
      return state.data
    }
  },
  mutations: {
    setHealthIndex: (state, healthIndex) => {
      state.data = healthIndex
    }
  },
  actions: {

  }

}

export default healthIndex
